import React from 'react';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';

export const ListBadgeHolder = (props: { children: React.ReactNode }) => {
  return <div className="grid grid-cols-2 gap-2">{props.children}</div>;
};

export const ListBadge: React.FC<{
  title: string;
  description: string;
  percent: number;
}> = ({ title, description, percent }) => {
  return (
    <div className="flex flex-row gap-2 items-center">
      <div className="flex-1">
        <Paragraph textColor={'text-secondary'} className="text-lg font-bold">
          {percent.toFixed(0)}%
        </Paragraph>
        <Paragraph textColor="text-gray-900" className="text-sm font-bold">
          {title}
        </Paragraph>
        <Paragraph className="text-xs">{description}</Paragraph>
      </div>
    </div>
  );
};
